import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TicketModel } from './models/ticket.model';
import { TokenModel } from './models/token.model';

@Injectable({
  providedIn: 'root'
})
export class SsoService {
  private token: TokenModel;
  private ticket: TicketModel;
  private timer = null;

  constructor(private http: HttpClient) { }

  public async getToken(): Promise<TokenModel> {
    try {
      this.token = null;
      // Preparo la cabecera
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      };
      const body = new URLSearchParams();
      body.set('grant_type', environment.grantTypeSSO);
      body.set('client_id', environment.clientIdSSO);
      body.set('client_secret', environment.clientSecretSSO);
      body.set('username', environment.userNameSSO);
      body.set('password', environment.passwordSSO);
      // Pido el token y lo guardo
      const ppp = environment.apiSSO;
      this.token = await this.http.post<TokenModel>(environment.apiSSO + '/sso/token',
        body.toString(), httpOptions).toPromise();
      sessionStorage.setItem('tokenSSO', this.token.access_token);
      // Activo un temporizador para pedir un nuevo token un minuto antes que caduque
      if (this.token.expires_in >= 120) {
        this.startTimer(this.token.expires_in - 60);
      } else {
        this.startTimer(Math.round(this.token.expires_in / 2));
      }
    } catch (e) {
      console.log(e);
    }
    return this.token;
  }

  // Devuelve el ticket almacenado actualmente
  public getTicket(): TicketModel {
    // Primero busco el que tengo en la sesión
    this.ticket = <TicketModel>JSON.parse(sessionStorage.getItem('ticketSSO'));
    if (!this.ticket) {
      // Si no hay en la sesión puede ser porque he iniciado la app escribiendo
      // directamente la URL en el navegador, entonces busco en el localstorage 
      // por si tengo un ticket válido almacenado de otro inicio
      this.ticket = <TicketModel>JSON.parse(localStorage.getItem('ticketSSO'));
      if (this.ticket) {
        sessionStorage.setItem('ticketSSO', JSON.stringify(this.ticket));
      }
    }
    return this.ticket;
  }

  // Permite saber si un usuario está validado en el SSO
  public async isUsuarioValidado(userId: number): Promise<boolean> {
    try {
      return await this.http.get<boolean>(environment.apiSSO + '/sso/usuario/validado/' + userId).toPromise();
    } catch {
    }
    return false;
  }

  // Inicia el temporizador para refrescar el token de la api
  private startTimer(interval: number) {
    this.stopTimer();
    this.timer = setTimeout(() => {
      this.getToken();
    }, interval * 1000);
  }

  // Finaliza el temporizador de refresco de token de la api
  private stopTimer() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.timer = null;
  }

  // Borra el ticket almacenado
  public endAppSession(): void {
    this.stopTimer();

    sessionStorage.removeItem('ticketSSO');
    sessionStorage.removeItem('ssoCrud-api');
    sessionStorage.removeItem('ssoCrud-web');

    window.location.replace(environment.webSSO);
  }


  // Valida un ticket en el SSO y devuelve la información
  private async validaTicket(ticketId: string): Promise<TicketModel> {
    try {
      return await this.http.get<TicketModel>(environment.apiSSO + '/sso/ticket/valida/' + ticketId).toPromise();
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  // Recupera la información de inicio de sesión del SSO
  public async initSession(ticketId: string): Promise<boolean> {
    try {
      this.ticket = null;
      if (ticketId !== undefined) {
        this.ticket = await this.validaTicket(ticketId);
        if (this.ticket !== null) {
          localStorage.setItem('ticketSSO', JSON.stringify(this.ticket));
          sessionStorage.setItem('ticketSSO', JSON.stringify(this.ticket));
          return true;
        }
      }
    } catch {
    }
    sessionStorage.removeItem('ticketSSO');
    return false;
  }


}
